import axios from "axios";
import { HTTPURL } from "../constants/Matcher";

// The API now wants a staff token on every admin, branch and teacher call.
// The three logins store it in userData.data.token. Rather than touch the
// ~75 files that call fetch or axios, add the header here, once, for any
// request that goes to our own API.

const readToken = () => {
  try {
    return JSON.parse(localStorage.getItem("userData"))?.data?.token || null;
  } catch (e) {
    return null;
  }
};

const isApi = (url) => Boolean(url) && Boolean(HTTPURL) && String(url).startsWith(HTTPURL);

// An expired or missing token comes back as 401. Sign out once and let the
// route guard send the person to the login page.
let signingOut = false;
const signOut = () => {
  if (signingOut) return;
  signingOut = true;
  try {
    localStorage.clear();
  } catch (e) {
    /* storage unavailable */
  }
  window.location.reload();
};

const nativeFetch = window.fetch.bind(window);

window.fetch = (input, init = {}) => {
  const url = typeof input === "string" ? input : input?.url;
  if (!isApi(url)) return nativeFetch(input, init);

  const token = readToken();
  const headers = new Headers(init.headers || (typeof input !== "string" ? input.headers : undefined));
  if (token && !headers.has("Authorization")) headers.set("Authorization", `Bearer ${token}`);

  return nativeFetch(input, { ...init, headers }).then((res) => {
    if (res.status === 401 && token) signOut();
    return res;
  });
};

axios.interceptors.request.use((config) => {
  const token = readToken();
  if (token && isApi(config.baseURL ? config.baseURL + (config.url || "") : config.url)) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && readToken()) signOut();
    return Promise.reject(err);
  }
);
